export default {
  state: {
    cancellation: {
      show: false,
      type: 'edit'
    }
  },
  mutations: {
    showCancellation (state) { state.cancellation.show = true },
    hideCancellation (state) { state.cancellation.show = false },
    setCancellationData (state, data) {
      for (let field in data) {
        state.cancellation[field] = data[field]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/rsvp-edit/cancellation.js